import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { FacebookCommentsInterface } from 'common/types/entities/FacebookCommentsInterface'
import React from 'react'
import FacebookCommentsUi from './ui/FacebookCommentsUi'

const FacebookCommentsPlaceholder = FacebookCommentsUi

interface FacebookCommentsProps {
  entity: FacebookCommentsInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function FacebookComments({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: FacebookCommentsProps) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <FacebookCommentsPlaceholder
        src={`${process.env.EDITOR_ASSETS_HOST}/assets/images/fb_comments.png`}
        alt=""
        width="100%"
      />
    </BaseEntityNew>
  )
}

export default FacebookComments
